<div>
  <!-- Porcentaje flotante encima de la barra (comentado) -->
  <!-- <h3
    *ngIf="!hiddePercent && hasData"
    class="font-sansMedium text-eggplant-100/[0.25] children:text-center children:top-[-12px] children:!-ml-24 relative pb-4 w-full">
    <span class="absolute text-m w-48" [ngStyle]="{ left: leftPercent + '%' }">{{ percent | number:'1.0-1':'es' }}%</span>
  </h3> -->

  <!-- Barra -->
  <div *ngIf="hasData" class="bar-grap-container" [ngClass]="{ 'h-12': size === 's', 'h-16': size === 'm' }">

    <!-- PRE-MÍNIMO (o sin mínimo): fondo gris + barra roja unificada -->
    <div *ngIf="!minExceeded"
      class="relative w-full rounded-[40px] bg-[#EAE7E9]"
      [ngClass]="{ 'h-12': size === 's', 'h-16': size === 'm' }">
      <div
        class="absolute left-0 z-10 rounded-l-[40px]"
        [ngClass]="{
          'rounded-r-[40px]': barWidthSingle >= 99,
          'h-12': size === 's',
          'h-16': size === 'm'
        }"
        [ngStyle]="{ width: barWidthSingle + '%', 'max-width': '100%', 'min-width': '2.5%', background: '#FF5C2F' }">
      </div>
    </div>

    <!-- POST-MÍNIMO: fondo verde claro + verde oscuro creciendo hacia el máximo -->
    <div *ngIf="minExceeded"
      class="relative w-full rounded-[40px]"
      [ngClass]="{ 'h-12': size === 's', 'h-16': size === 'm' }"
      [ngStyle]="{ background: '#62BE7F' }">
      <div
        class="absolute left-0 z-10 rounded-l-[40px]"
        [ngClass]="{
          'rounded-r-[40px]': barWidthGreenDark >= 100,
          'h-12': size === 's',
          'h-16': size === 'm'
        }"
        [ngStyle]="{ width: barWidthGreenDark + '%', 'max-width': '100%', 'min-width': '2.5%', background: '#15803d' }">
      </div>
    </div>

  </div>

  <!-- Objetivos: siempre visibles si !hiddeObjetive -->
  <div *ngIf="!hiddeObjetive" class="flex flex-col gap-6">
    <div class="flex gap-4 w-full justify-between">
      <p *ngIf="data.total_official > 0" class="text-left font-sans text-s md:text-m"
        [ngClass]="{ 'text-success': minExceeded, 'text-eggplant-100/[0.25]': !minExceeded }">
        <ng-container *ngIf="!minExceeded">Objetivo mín.: {{ data.total_official | number:'1.0-2':'es' }} €</ng-container>
        <ng-container *ngIf="minExceeded">✓ Mín.: {{ data.total_official | number:'1.0-2':'es' }} €</ng-container>
      </p>
      <p class="text-right font-sans text-s md:text-m text-eggplant-100/[0.25] ml-auto">Objetivo: {{ objetiveParse }}</p>
    </div>
  </div>

  <!-- Leyenda: importes invertido y reservado -->
  <div
    *ngIf="!hiddeLegend && data.contributed > 0"
    class="flex gap-16 pt-6 justify-between">
    <span class="font-sans text-m text-[#FF5C2F]" *ngIf="data.contributed > 0">
      Invertido {{ data.contributed | number:'1.0-0':'es' }} €
    </span>
    <span class="font-sans text-m text-[#FFD43C] ml-auto text-right" *ngIf="data.reservedDisplayAmount > 0">
      Reservado {{ data.reservedDisplayAmount | number:'1.0-0':'es' }} €
    </span>
  </div>

</div>
